var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.5508H103.439L103.582 43.4504L103.445 95.1645H0.00553485L0.14335 43.4477L0 16.5508ZM4.27542 45.5137L4.15414 91.0269H99.3181L99.4394 45.5137H4.27542ZM99.4338 41.3762L99.3236 20.6883H4.15967L4.26993 41.3762H99.4338Z",
    fill: "url(#paint0_linear_908_1051)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.588 12.413H10.3555V8.27539H111.726V84.8203H107.588V12.413Z",
    fill: "#7A9CF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.862 4.13756H18.6289V0H119.999V76.5449H115.862V4.13756Z",
    fill: "#A7BDF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.493 35.1697C16.7781 35.1697 18.6306 33.3172 18.6306 31.0321C18.6306 28.747 16.7781 26.8945 14.493 26.8945C12.2079 26.8945 10.3555 28.747 10.3555 31.0321C10.3555 33.3172 12.2079 35.1697 14.493 35.1697Z",
    fill: "url(#paint1_linear_908_1051)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0419 35.1697C33.327 35.1697 35.1794 33.3172 35.1794 31.0321C35.1794 28.747 33.327 26.8945 31.0419 26.8945C28.7567 26.8945 26.9043 28.747 26.9043 31.0321C26.9043 33.3172 28.7567 35.1697 31.0419 35.1697Z",
    fill: "url(#paint2_linear_908_1051)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5907 35.1697C49.8758 35.1697 51.7282 33.3172 51.7282 31.0321C51.7282 28.747 49.8758 26.8945 47.5907 26.8945C45.3056 26.8945 43.4531 28.747 43.4531 31.0321C43.4531 33.3172 45.3056 35.1697 47.5907 35.1697Z",
    fill: "url(#paint3_linear_908_1051)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_1051",
    x1: -7.31699e-7,
    y1: 88.1847,
    x2: 105.155,
    y2: 79.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_908_1051",
    x1: 10.3555,
    y1: 34.4349,
    x2: 18.7815,
    y2: 33.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_908_1051",
    x1: 26.9043,
    y1: 34.4349,
    x2: 35.3304,
    y2: 33.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_908_1051",
    x1: 43.4531,
    y1: 34.4349,
    x2: 51.8792,
    y2: 33.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApp);
export default __webpack_public_path__ + "static/media/web-app.64ace918f9e4c460988ce230114cfcce.svg";
export { ForwardRef as ReactComponent };